import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { viewStates, pdfLinks } from "../constants";
import { defaultTitle } from "../config";
import { GleamPanel } from "./Utility/GleamPanel";
import { BsArrowClockwise } from "react-icons/bs";
import { Link, useHistory, useParams } from "react-router-dom";
//custom hooks
import {
  getDeliveryConcern,
  reopenDeliveryConcern,
} from "../services/deliveryConcernService";
import useForm from "../hooks/useForm";
// import postDeliveryConcern from "./PostDeliveryConcern";
import handleApiError from "../helpers/handleApiError";
import { toast } from "react-toastify";
import { OrderInfoDisplay } from "./Utility/OrderInfoDisplay";

const InvoiceTemplate = {
  invoiceNumber: "",
  isPurchasingInsurance: false,
  declaredValue: "",
};

const DeliveryDetailsFullRework = ({ setLoading }) => {
  const [reopenDeliveryConcernCheckbox, setReopenDeliveryConcernCheckbox] =
    useState(true);

  const [customerSelectionType, setCustomerSelectionType] =
    useState("existing");
  const [cityAndState, setCityAndState] = useState("");
  const [customer, setCustomer] = useState("");
  const [customerInfo, setCustomerInfo] = useState({});

  const { id: deliveryConcernId } = useParams();
  const history = useHistory();
  const [openDeliveryConcern, setOpenDeliveryConcern] = useState(false);
  //STATES
  const [formValues, setFormValues] = useForm({
    problemDescription: "",
  });
  const [deliveryConcern, setDeliveryConcern] = useState();
  const [viewState, setViewState] = useState(viewStates.loading);

  const [accountNumberToLookup, setAccountNumberToLookup] = useState("");
  const handleChangeAccountNumber = (e) => {
    setAccountNumberToLookup(e.target.value);
  };
  const [customerToShow, setCustomerToShow] = useState();
  const [showCustomerByAccount, setShowCustomerByAccount] = useState(false);
  const lookupAccount = () => {
    setShowCustomerByAccount(true);
    setCustomerToShow(customersWithAccountNumbers[accountNumberToLookup]);
  };

  const [customersWithAccountNumbers, setCustomersWithAccountNumbers] =
    useState({
      1: {
        name: "California Mechanic with an account TM",
        address: "LA",
        email: "wechargeperminuteforparking@california.gov",
        phone: "915-555-5555",
      },
      2: {
        name: "We Killed the Dragon Car Rentals",
        address: "Lumby",
        email: "chosenonescape@rsprivateservers.com",
        phone: "925-555-5555",
      },
      3: {
        name: "__f0rtnitepro___52",
        address: "Tencent HQ",
        email: "contact@epicgames.com",
        phone: "935-555-5555",
      },
    });
  const [orderInfo, setOrderInfo] = useState({ comments: "" });
  const handleChangeOrderInfo = (e) => {
    const { name, value } = e.target;
    setOrderInfo({ ...orderInfo, [name]: value });
  };
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   setLoading(true);

  //   let orderRequest = {};

  //   const orderRequestBase = {
  //     pieceCount: commonOrderFormValues.pieceCount,
  //     comment: commonOrderFormValues.comment,
  //     timeCode: customerSelectionFormValues.timeCode,
  //     weight: commonOrderFormValues.weight,
  //     pieceType: commonOrderFormValues.pieceType
  //       ? commonOrderFormValues.pieceType.trim()
  //       : "",
  //     callTag: formValues.callTag,
  //     contactName: formValues.contactName,
  //     contactPhone: formValues.contactPhone,
  //     emailAddress: formValues.emailAddress,
  //   };

  //   if (customerSelectionFormValues.customerSelectionType === "account") {
  //     const customerAccountBase = {
  //       customerAccountId: customerAccountId,
  //     };

  //     orderRequest = { ...orderRequestBase, ...customerAccountBase };
  //   } else if (customerSelectionFormValues.customerSelectionType === "manual") {
  //     const manualCustomerBase = {
  //       customerName: manualCustomerFormValues.customerName,
  //       customerAddress: manualCustomerFormValues.customerAddress,
  //       customerCity: manualCustomerFormValues.customerCity,
  //       customerStateAbbreviation:
  //         manualCustomerFormValues.customerStateAbbreviation,
  //       customerZipCode: manualCustomerFormValues.customerZipCode,
  //       customerPhoneNumber: manualCustomerFormValues.customerPhoneNumber,
  //     };

  //     orderRequest = { ...orderRequestBase, ...manualCustomerBase };
  //   } else {
  //     const normalCustomerBase = {
  //       customerId: customerId,
  //     };

  //     orderRequest = { ...orderRequestBase, ...normalCustomerBase };
  //   }

  //   try {
  //     const { data: response } = await postBuyout(orderRequest);

  //     toast.success("Order has been posted.");

  //     const redirectUrl = generatePath("/view-labels/:id", {
  //       id: response.deliveryId,
  //     });

  //     window.open(redirectUrl, "_blank");

  //     setLoading(false);
  //   } catch (ex) {
  //     setLoading(false);
  //     handleApiError(ex, history);
  //   }
  // };
  //==============================Invoice List Section ==================================//
  const [valuationRate, setValuationRate] = useState(0.006); //*******REPLACE THIS WITH VALUE RECEIVED FROM BACKEND - MAKE SURE TO ADJUST FOR DECIMAL PLACES - IT IS SUPPOSED TO BE .6% in the end!!!!!************
  const [invoices, setInvoices] = useState([{ ...InvoiceTemplate }]);
  const handleChangeInvoiceNumber = (e, invoiceIndex) => {
    // console.log(
    //   "changing invoice number of " + invoiceIndex + " to: " + e.target.value
    // );
    let updatedInvoices = [...invoices];
    //probably need to update this to spread the object into a new object but not 100% sure since we already spread the whole array.
    //NEEED to look into this **********
    updatedInvoices[invoiceIndex].invoiceNumber = e.target.value;
    // console.log(invoices);
    setInvoices(updatedInvoices);
  };

  //=================================END INVOICE LIST SECTION==========================================================//

  const handleSelectCityAndState = (e) => {
    //remember to empty the customer list so the user cannot select a customer from the city/state they were currently on before the api fetches new data/fails to fetch
    //either reset the customer list before the api call
    //or setCustomer("") after the api call and remember to handle api fetch failing(probably need to either way);
    setCustomer(""); //when we change city/state, reset customer to blank
    setCityAndState(e.target.value);
  };
  const handleSelectCustomer = (e) => {
    // console.log("Customer is: " + e.target.value);
    if (e.target.value === "") {
      // if they select "Select Customer"
      setCustomer("");
    } else {
      // take the customer out of the list
      //update the list of customers
      setCustomer(0); //set the customer index to 0, as we moved the selected customer to that index, it will always be 0 but we set it to 0 here because if they select "Select Customer" we set it to "" (maybe we can omit that later)
    }
  };

  const handleChangeCustomerSelectionType = (e) => {
    setCustomerSelectionType(e.target.value);
  };
  useEffect(() => {
    (async () => {
      setLoading(true);
      setViewState(viewStates.loading);

      try {
        const { data: foundDeliveryConcern } = await getDeliveryConcern(
          deliveryConcernId
        );

        // console.log(foundDeliveryConcern);

        setDeliveryConcern(foundDeliveryConcern);

        setLoading(false);
        setViewState(viewStates.success);
      } catch (ex) {
        handleApiError(ex, history);
        setLoading(false);
        setViewState(viewStates.error);
      }
    })();
  }, [deliveryConcernId]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formValues.problemDescription.length === 0) {
      toast.error("Please enter a description for your issue.");
      return;
    }
    setLoading(true);
    try {
      // const { data: deliveryConcernId } = await postDeliveryConcern({
      //   deliveryConcernId,
      //   ...formValues,
      // });
      const response = await reopenDeliveryConcern({
        deliveryConcernId,
        ...formValues,
      });
      // console.log(response);
      toast.success("Your concern was successfully reopened.");
      setLoading(false);
      // history.push(`/delivery-concern/${deliveryConcernId}`); // history.push to the same page does not seem to do anything, we could refresh the page instead.
      history.push("/delivery-concern"); // sending to the concern table for now
    } catch (ex) {
      handleApiError(ex, history);
      setLoading(false);
    }
  };
  const handleOnInvalid = (e) => {
    e.preventDefault();
    if (formValues.problemDescription.length === 0) {
      toast.error("Please enter a description for your issue.");
      return;
    }
  };
  const reopenDC = () => {
    setReopenDeliveryConcernCheckbox(!reopenDeliveryConcernCheckbox);
  };

  const renderDecider = () => {
    switch (viewState) {
      case viewStates.success:
        return (
          <>
            <div className="container paper-panel sub-panel">
              <div className="row sub-panel-header align-items-center">
                <div className="col-12">
                  <label className="font-weight-bold">
                    Concern Information
                  </label>
                </div>
              </div>
              <div className="row p-2">
                <OrderInfoDisplay
                  label="Incident Number"
                  info={deliveryConcern.tranId}
                />
                <OrderInfoDisplay
                  label="Entered On"
                  infoType="date"
                  info={deliveryConcern.enteredOn}
                />
                <OrderInfoDisplay
                  label="Caller"
                  info={deliveryConcern.caller}
                />
                <OrderInfoDisplay
                  label="Callback Number"
                  info={deliveryConcern.callBack}
                />
                <OrderInfoDisplay
                  label="Entered By"
                  info={deliveryConcern.addBy}
                />
              </div>
            </div>
            <div className="container paper-panel sub-panel">
              <div className="row sub-panel-header align-items-center">
                <div className="col-12">
                  <label className="font-weight-bold">Order Information </label>
                </div>
              </div>
              <div className="row p-2">
                <OrderInfoDisplay
                  label="Delivery ID"
                  info={deliveryConcern.deliveryId}
                />
                <OrderInfoDisplay
                  label="Invoice Number"
                  info={deliveryConcern.invoiceNumber}
                />
                <OrderInfoDisplay
                  label="Customer Name"
                  info={deliveryConcern.customer}
                />
                <OrderInfoDisplay
                  label="Dealer"
                  info={deliveryConcern.dealer}
                />
                <OrderInfoDisplay label="Route" info={deliveryConcern.route} />
                <OrderInfoDisplay
                  label="Ship Date"
                  infoType="date"
                  info={deliveryConcern.shipDate}
                />
                <OrderInfoDisplay label="City" info={deliveryConcern.city} />
              </div>
            </div>
            <div className="container paper-panel sub-panel">
              <div className="row sub-panel-header align-items-center">
                <div className="col-6">
                  <div className="font-weight-bold">Problem and Resolution</div>
                </div>
              </div>
              <div className="delivery-concern-dialogue-item row">
                <div className="delivery-concern-dialogue-problem-description col-md-6">
                  <div className="font-500">Problem Description</div>
                  {deliveryConcern.description}
                </div>
                <div className="delivery-concern-dialogue-problem-resolution col-md-6">
                  <div className="font-500">Resolution</div>
                  {deliveryConcern.resolution
                    ? deliveryConcern.resolution
                    : "Resolution Pending"}
                </div>
              </div>
              {deliveryConcern.description2 && (
                <div className="delivery-concern-dialogue-item row">
                  <div className="delivery-concern-dialogue-problem-description col-md-6">
                    <div className="font-500">Problem Description 2</div>
                    {deliveryConcern.description2}
                  </div>
                  <div className="delivery-concern-dialogue-problem-resolution col-md-6">
                    <div className="font-500">Resolution 2</div>
                    {deliveryConcern.resolution2
                      ? deliveryConcern.resolution2
                      : "Resolution Pending"}
                  </div>
                </div>
              )}
              {deliveryConcern.description3 && (
                <div className="delivery-concern-dialogue-item row">
                  <div className="delivery-concern-dialogue-problem-description col-md-6">
                    <div className="font-500">Problem Description 3</div>
                    {deliveryConcern.description3}
                  </div>
                  <div className="delivery-concern-dialogue-problem-resolution col-md-6">
                    <div className="font-500">Resolution 3</div>
                    {deliveryConcern.resolution3
                      ? deliveryConcern.resolution3
                      : "Resolution Pending"}
                  </div>
                </div>
              )}
              {deliveryConcern.description4 && (
                <div className="delivery-concern-dialogue-item row">
                  <div className="delivery-concern-dialogue-problem-description col-md-6">
                    <div className="font-500">Problem Description 4</div>
                    {deliveryConcern.description4}
                  </div>
                  <div className="delivery-concern-dialogue-problem-resolution col-md-6">
                    <div className="font-500">Resolution 4</div>
                    {deliveryConcern.resolution4
                      ? deliveryConcern.resolution4
                      : "Resolution Pending"}
                  </div>
                </div>
              )}
              {/* <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              height: "200px",
              overflow: "auto",
              border: "1px solid rgba(0,0,0,.2)",
              borderRadius: "10px",
              padding: "32px",
              paddingLeft: "15px",
              paddingRight: "15px",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "right",
              }}
            >
              <div
                style={{
                  backgroundColor: "rgb(150,255,150)",
                  width: "fit-content",
                  padding: "10px",
                  borderRadius: "20px 20px 0px 20px",
                }}
              >
                {deliveryConcern?.description}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "left",
              }}
            >
              <div
                style={{
                  backgroundColor: "rgb(150,255,255)",
                  width: "fit-content",
                  padding: "10px",
                  borderRadius: "20px 20px 20px 0px",
                }}
              >
                {deliveryConcern?.resolution}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "right",
              }}
            >
              <div
                style={{
                  backgroundColor: "rgb(150,255,150)",
                  width: "fit-content",
                  padding: "10px",
                  borderRadius: "20px 20px 0px 20px",
                }}
              >
                {deliveryConcern?.description2}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "left",
              }}
            >
              <div
                style={{
                  backgroundColor: "rgb(150,255,255)",
                  width: "fit-content",
                  padding: "10px",
                  borderRadius: "20px 20px 20px 0px",
                }}
              >
                {deliveryConcern?.resolution2}
              </div>
            </div>
          </div> */}
              {deliveryConcern.status === "Closed" ? (
                <div className="row p-2">
                  <div className="col-lg-12">
                    <div className="form-group ">
                      <label className="font-weight-bold">
                        Reopen Concern? &nbsp;{" "}
                        <input
                          type="checkbox"
                          onClick={reopenDC}
                          aria-label="Reopen Concern"
                        />
                      </label>{" "}
                      {reopenDeliveryConcernCheckbox ? (
                        <div></div>
                      ) : (
                        <form
                          onSubmit={handleSubmit}
                          onInvalid={handleOnInvalid}
                        >
                          <div>
                            <label>
                              New Problem Description
                              <span className="required-star">*</span>
                            </label>
                            <textarea
                              required
                              name="problemDescription"
                              value={formValues.problemDescription}
                              onChange={setFormValues}
                              className="form-control"
                            />
                          </div>
                          <p>
                            By submitting your delivery concern, you agree to
                            our{" "}
                            <Link
                              target="_blank"
                              rel="noopener noreferrer" //might not be necessary unless linking to a different site or in modern browsers. not 100% sure, need to research
                              to={pdfLinks.termsAndConditions}
                            >
                              terms and conditions
                            </Link>
                            .
                          </p>
                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </>
        );
      case viewStates.loading:
        return (
          <>
            <GleamPanel
              height="250px"
              className="paper-panel-always sub-panel"
            />
            <GleamPanel
              height="250px"
              className="paper-panel-always sub-panel"
            />
            <GleamPanel
              height="300px"
              className="paper-panel-always sub-panel"
            />
          </>
        );
      case viewStates.error:
        return (
          <div
            // style={{
            //   position: "absolute",
            //   top: "0",
            //   left: "0",
            //   right: "0",
            //   bottom: "0",
            //   display: "grid",
            //   placeContent: "center",
            //   textAlign: "center",
            // }}
            style={{
              paddingTop: "300px",
              paddingBottom: "300px",
              textAlign: "center",
            }}
          >
            There was an issue processing your request. Please try refreshing
            the page.
            <br />
            <button
              onClick={() => {
                window.location.reload();
              }}
              style={{
                outline: "none",
                border: "none",
                margin: "10px",
                backgroundColor: "transparent",
                fontSize: "1.5rem",
              }}
            >
              <BsArrowClockwise />
            </button>
          </div>
        );
      case viewStates.nodata:
        return (
          <div
            // style={{
            //   position: "absolute",
            //   top: "0",
            //   left: "0",
            //   right: "0",
            //   bottom: "0",
            //   display: "grid",
            //   placeContent: "center",
            //   textAlign: "center",
            // }}
            style={{
              paddingTop: "300px",
              paddingBottom: "300px",
              textAlign: "center",
            }}
          >
            There was an issue processing your request. Please try refreshing
            the page.
            <br />
            <button
              onClick={() => {
                window.location.reload();
              }}
              style={{
                outline: "none",
                border: "none",
                margin: "10px",
                backgroundColor: "transparent",
                fontSize: "1.5rem",
              }}
            >
              <BsArrowClockwise />
            </button>
          </div>
        );
    }
  };

  return (
    <>
      <Helmet>
        <title>View Delivery Concern - {defaultTitle}</title>
      </Helmet>
      <div className="container paper-panel form-container">
        <div className="row">
          <div className="col form-header">
            <h1>Delivery Concern #{deliveryConcernId}</h1>
            <p>
              {/* <span className="required-star">*</span> denotes a required field. */}
            </p>
          </div>
        </div>
        {renderDecider()}
      </div>
    </>
  );
};

export default DeliveryDetailsFullRework;

// import React, { useEffect, useState } from "react";

// //custom libraries
// import handleApiError from "../helpers/handleApiError";

// //third party libraries
// import { useHistory, useParams } from "react-router-dom";
// import DeliveryDetailsFullRework from "./DeliveryDetailFullRework";
// //custom hooks
// import useForm from "../hooks/useForm";

// //services
// import {
//   getDeliveryConcern,
//   reopenDeliveryConcern,
// } from "../services/deliveryConcernService";
// import { defaultTitle } from "../config.json";
// import { Helmet } from "react-helmet";

// const ViewDeliveryDetailFullRework = ({ setLoading }) => {
//   //CONSTANTS
//   const { id: deliveryConcernId } = useParams();
//   const history = useHistory();
//   const [openDeliveryConcern, setOpenDeliveryConcern] = useState(false);
//   //STATES
//   const [formValues, setFormValues] = useForm({
//     problemDescription: "",
//   });
//   const [reopenDeliveryConcern, setReopenDeliveryConcern] = useState(true);
//   const [deliveryConcern, setDeliveryConcern] = useState();

//   //EVENT HANDLERS
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setLoading(true);

//     try {
//       const { data } = await reopenDeliveryConcern({
//         deliveryConcernId,
//         ...formValues,
//       });

//       window.location.reload();
//     } catch (ex) {
//       setLoading(false);
//       handleApiError(ex, history);
//     }
//   };
//   const reopenDC = () => {
//     setReopenDeliveryConcern(!reopenDeliveryConcern);
//   };
//   //EFFECTS
//   useEffect(() => {
//     (async () => {
//       setLoading(true);

//       try {
//         const { data: foundDeliveryConcern } = await getDeliveryConcern(
//           deliveryConcernId
//         );

//         setDeliveryConcern(foundDeliveryConcern);

//         setLoading(false);
//       } catch (ex) {
//         setLoading(false);
//         handleApiError(ex, history);
//       }
//     })();
//   }, [deliveryConcernId]);

//   const getResolutionJsx = (num, description, resolution) => {
//     return (
//       <React.Fragment>
//         <tr>
//           <td>Problem Description {num}</td>
//           <td>{description}</td>
//         </tr>
//         <tr>
//           <td>Resolution {num}</td>
//           <td>{resolution}</td>
//         </tr>
//       </React.Fragment>
//     );
//   };

//   return (
//     <React.Fragment>
//       <br />
//       <div className="delivery-concern-page">
//         <div className="paper-delivery-concerns">
//           <Helmet>
//             <title>Delivery Concern - Rework {defaultTitle}</title>
//           </Helmet>
//           <h1>Delivery Concern-Rework </h1>
//           <br />
//           {deliveryConcern && (
//             <React.Fragment>
//               <table className="table table-sm">
//                 <tr>
//                   <td>Incident No</td>
//                   {/* <dd>76998</dd> */}
//                   <td>{deliveryConcern.tr}anId</td>
//                 </tr>
//                 <tr>
//                   <td>Entered Date/Time</td>
//                   <td>{deliveryConcern.enteredOn}</td>
//                 </tr>
//                 <tr>
//                   <td>Caller</td>
//                   <td>{deliveryConcern.caller}</td>
//                 </tr>
//                 <tr>
//                   <td>Call Back Number</td>
//                   <td>{deliveryConcern.callBack}</td>
//                 </tr>
//                 <tr>
//                   <td>Route</td>
//                   <td>{deliveryConcern.route}</td>
//                 </tr>
//                 <tr>
//                   <td>Ship Date</td>
//                   <td>{deliveryConcern.shipDate}</td>
//                 </tr>
//                 <tr>
//                   <td>Customer</td>
//                   <td>{deliveryConcern.customer}</td>
//                 </tr>
//                 <tr>
//                   <td>City</td>
//                   <td>{deliveryConcern.city}</td>
//                 </tr>
//                 <tr>
//                   <td>Dealer Code</td>
//                   <td>{deliveryConcern.dealer}</td>
//                 </tr>
//                 <tr>
//                   <td>Entered By</td>
//                   <td>{deliveryConcern.addBy}</td>
//                 </tr>
//                 <tr>
//                   <td>Problem Description</td>
//                   <td>{deliveryConcern.description}</td>
//                 </tr>
//                 <tr>
//                   <td>Resolution</td>
//                   <td>{deliveryConcern.resolution}</td>
//                 </tr>
//                 {deliveryConcern.description2 &&
//                   getResolutionJsx(
//                     2,
//                     deliveryConcern.description2,
//                     deliveryConcern.resolutionN2
//                   )}
//               </table>

//               {deliveryConcern.description2 ? (
//                 deliveryConcern.resolutionN2 ? (
//                   <p>
//                     If you are still having issues with this order, please
//                     contact Diligent.
//                   </p>
//                 ) : (
//                   <p>Please wait for a resolution from Diligent.</p>
//                 )
//               ) : (
//                 <React.Fragment>
//                   <h4>
//                     Reopen Concern? &nbsp;
//                     <input
//                       onClick={reopenDC}
//                       type="checkbox"
//                       aria-label="Reopen Concern"
//                     />
//                     {reopenDeliveryConcern ? (
//                       <div></div>
//                     ) : (
//                       <form onSubmit={handleSubmit}>
//                         <div className="form-group">
//                           <h5>Problem Description</h5>
//                           <textarea
//                             name="problemDescription"
//                             value={formValues.problemDescription}
//                             onChange={setFormValues}
//                             className="form-control"
//                           />
//                         </div>
//                         <button className="btn btn-primary" type="submit">
//                           Send
//                         </button>
//                       </form>
//                     )}
//                   </h4>
//                 </React.Fragment>
//               )}
//             </React.Fragment>
//           )}
//         </div>
//       </div>
//       <h4> Hi</h4>
//     </React.Fragment>
//   );
// };

// export default ViewDeliveryDetailFullRework;
